<script>
import { mapActions } from 'vuex'
import { useAlert } from 'dashboard/composables';

export default {
  name: 'BulkDeleteModal',
  props: {
    selectedInbox: { type: Object, required: true },
    deleteTargetIds: { type: Array, required: true },
  },
  data() {
    return {
      isLoading: false,
    }
  },
  methods: {
    ...mapActions('whitelist', ['deleteWhitelistQuestion']),
    async handleDelete() {
      if (!this.selectedInbox.id) {
        useAlert('Please select an inbox first')
        return
      }
      this.isLoading = true
      try {
        const results = await Promise.allSettled(
          this.deleteTargetIds.map(targetId =>
            this.deleteWhitelistQuestion({
              accountId: this.$route.params.accountId,
              inboxId: this.selectedInbox.id,
              questionId: targetId,
            })
          )
        )
        
        const failures = results.filter(r => r.status === 'rejected').length
        const successes = results.filter(r => r.status === 'fulfilled').length
        
        if (failures === 0) {
          useAlert('Questions deleted successfully!')
        } else if (successes === 0) {
          useAlert('Failed to delete questions')
        } else {
          useAlert(`${successes} questions deleted, ${failures} failed`)
        }
        
        if (successes > 0) {
          this.$emit('refresh')
          this.$emit('close')
        }
      } catch (e) {
        useAlert('Failed to delete questions')
      } finally {
        this.isLoading = false
      }
    },
  }
}
</script>

<template>
  <div
    class="fixed inset-0 flex items-center justify-center bg-slate-800/50 z-50"
  >
    <div class="bg-white dark:bg-slate-800 rounded-lg p-6 shadow-lg w-96">
      <h2 class="text-lg font-semibold text-slate-800 dark:text-slate-200 mb-4">
        Confirm Deletion
      </h2>
      <div class="mb-6">
        <p class="text-slate-600 dark:text-slate-300 mb-4">
          Are you sure you want to delete the selected questions? This action cannot be undone.
        </p>
      </div>

      <div class="flex justify-end gap-3">
        <woot-button
          variant="clear"
          color-scheme="secondary"
          @click="$emit('close')"
          :disabled="isLoading"
        >
          Cancel
        </woot-button>
        <woot-button
          variant="smooth"
          color-scheme="alert"
          @click="handleDelete"
          :disabled="isLoading"
          :loading="isLoading"
        >
          {{ isLoading ? 'Deleting...' : 'Delete' }}
        </woot-button>
      </div>
    </div>
  </div>
</template>
